import axios from "axios";

const API_BASE_URL = process.env.REACT_APP_API_BASEURL + "/DigitalAssets";

export const deactivateDigitalAssets = async (
  ids: number[]
): Promise<void> => {
  await axios.delete(API_BASE_URL, { data: ids });
};
